module.exports = __webpack_public_path__ + "static/media/camera.d42e372b.svg";